<div 
  class="youtube-wrapper"
  *ngIf="embedUrl"
>
  <iframe
    [src]="embedUrl | safeUrl"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
  ></iframe>
</div>
